module.exports = __webpack_public_path__ + "static/media/github-edit-file.5a5915d2.png";